// « Plus » : les écrans d'administration et d'usage occasionnel, hors du chemin principal de saisie.
import Icone from '../components/Icones.tsx';
export interface LienPlus { page: string; label: string; aide: string }
const ICONES: Record<string, string> = {
  HISTORIQUE: 'hist', SYNCHRO: 'sync', PARAMETRES: 'param', ABONNEMENT: 'abo', PAIEMENTS: 'fin', ADMIN_COMPTES: 'admin',
  VALIDATION: 'valid', ADMIN_ACCES: 'verrou', ADMIN_ABONNEMENTS: 'abo', REFERENTIELS: 'ref',
};
export default function Plus({ liens, onAller }: { liens: LienPlus[]; onAller: (p: string) => void }) {
  return (
    <div>
      <h1>Plus</h1>
      <div className="grille-cartes">
        {liens.map((l) => (
          <button key={l.page + l.label} className="carte-action c6" onClick={() => onAller(l.page)}>
            <span className="icone" aria-hidden="true"><Icone nom={ICONES[l.page] ?? 'ok'} /></span>
            <b>{l.label}</b><span>{l.aide}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
